// Import dependencies
import { unsafeCSS, css, html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';

// Import escapeHTML
import { escapeHTML } from '@wordpress/escape-html';

// Import i18n functions
import { __ } from '@wordpress/i18n';

// Import style for web component
import styles from './web-component-style.scss?inline';

// eslint-disable-next-line require-jsdoc
@customElement( 'uap-builder-publish-quick-action-download' )
export class AutomatorBuilderPublishQuickActionDownload extends LitElement {
	// Define style
	static styles = css`${ unsafeCSS( styles ) }`;

	// eslint-disable-next-line require-jsdoc
	render() {
		return html`
			<uo-tooltip>
				${ escapeHTML( __( 'Download recipe', 'uncanny-automator' ) ) }

				<uo-button
					slot="target"
					size="small"
					color="transparent"

					href=${ UncannyAutomator._recipe.miscellaneous.url_download_recipe }
				>
					<uo-icon id="download"></uo-icon>
				</uo-button>
			</uo-tooltip>
		`;
	}
}